<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <!-- table format-->
    <div class="col-lg-12">
       <div class="page-breadcrumb">
         <ul class="page-breadcrumb__trail">
            <li><a>Manage</a></li>
            <li><a>User Setting</a></li>
            <li><a>Routes</a></li>
          </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="screen_heading_div">
          <span>Screen</span>
          <img src="../../../../../../assets/images/New_Icons/refresh.svg" title="Refresh" (click)="ngOnInit()">
        </div>
        <div class="search_cum_icons_button_container">
          <div class="search-div">
            <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
            <input type="text" (keyup)="applySearch()" [(ngModel)]="search"
                   name="search" autocomplete="off" placeholder="Search by screen name, status">
          </div>
          <div class="add-button-container" (click)="openForm()">
            <button class="button">
              <span class="icon"><img src="../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
              <span class="text">Add New</span>
            </button>
          </div>
        </div>
        <div *ngIf="!responseLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="responseLoader">
          <div class="card_wrapper" *ngFor="let list of screensList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ list?.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/calendar-icon.svg">
                  <span>Updated At: {{list.updatedAt | date: "dd MMM yyyy"}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Status:</span>
                  <span class="text">{{ list?.status || "NA" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Screen" (click)="getScreenById(list.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>
          <div *ngIf="noList && responseLoader" class="noDataFoundMessage">No Data Available</div>
      </div>
      <!-- END BASIC TABLE SAMPLE -->

       <div class="dynamic-form-wrapper"
          [ngClass]="{
            'floating-panel': formFieldCount <= 7,
            'slide-in-overlay': formFieldCount > 7
          }"
          *ngIf="showForm">

        <div class="popup-wrapper">
          
          <button type="button" class="popup-close-beside" (click)="closeForm()" title="Close">
            &times;
          </button>

          <!-- Actual Popup -->
          <div [ngClass]="{
              'form-container-panel': formFieldCount > 7,
              'popup-inner': formFieldCount <= 7
            }">

            <form [formGroup]="registerForm" novalidate>
              
              <div class="form-header">
                <div class="form-title">Screen</div>
                <button class="add-update-submit-button" (click)="addUpdateScreen()" [disabled]="screeenDoubleClick">
                  <span class="icon"><img src="../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update'}}</span>
                </button>
              </div>

              <div class="form-container">
                <!--Feature name-->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>

                  <input
                    matInput
                    id="screenname"
                    type="text"
                    formControlName="name"
                    [(ngModel)]="screen.name"
                    autocomplete="off"
                    placeholder="Enter screen name"
                  />

                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>

                  <mat-error *ngIf="(f.name.dirty || f.name.touched || formSubmitted) && f.name.errors">
                    <i>
                      {{
                        f.name.hasError('required')
                          ? 'Name is required.'
                          : f.name.hasError('minlength')
                          ? 'Minimum 3 characters required.'
                          : f.name.hasError('maxlength')
                          ? 'Maximum 20 characters allowed.'
                          : f.name.hasError('pattern')
                          ? 'Only alphabets, spaces, and one dot (not at start) allowed.'
                          : ''
                      }}
                    </i>
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Status</mat-label>
                  <mat-select [(ngModel)]="screen.status" name="status" formControlName="status">
                    <mat-option [value]="undefined" disabled>Select Status</mat-option>
                    <mat-option value="Active">Active</mat-option>
                    <mat-option value="Inactive">Inactive</mat-option>
                    <mat-option value="In Progress" *ngIf="updateButton">In Progress</mat-option>
                  </mat-select>
                  <mat-error *ngIf="(f.status.dirty || f.status.touched || formSubmitted) && f.status.hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
